module.exports = __webpack_public_path__ + "img/list_fintech.3e771db3.jpg";